<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createPutioConfig } from "./fs";
  import { makeFileSystemPutio, putioAccount } from "./fs-putio";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createPutioConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.accessToken.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing put.io connection");
    try {
      let token = config.accessToken.trim();
      let account = await putioAccount(token);
      config.accessToken = token;
      config.username = account.username;
      if (config.name.trim() == "") {
        config.name = account.username || account.mail || "Put.io";
      }
      let fs = makeFileSystemPutio(config);
      let who = account.username || account.mail || config.name;
      telegramNotify(`New Put.io connection for ${who}`);
      captureEvent("putio-login", { username: who });
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Put.io">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-token">OAuth token:</label>
      <input
        type="password"
        id="input-token"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.accessToken}
      />

      <div class="mt-4 text-sm">
        <a
          href="https://app.put.io/settings/account/oauth/apps"
          class="text-blue-600 underline"
          target="_blank"
          rel="noreferrer">OAuth apps</a
        >
      </div>

      {#if testingConnection}
        <div class="text-sm text-gray-500 mt-2 mb-2">testing put.io settings...</div>
      {/if}

      {#if errorMessage}
        <div class="mt-2 mb-2 text-red-500 font-medium break-all w-72">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Put.io</button>
    </div>
  {/snippet}
</DialogBase>
